
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    root: {
    }
});

const InfoNotFound = () => {
    return (
        <div className={classNames.root}>
            <Text>Požadované informace nebyly nalezeny</Text>
        </div>
    );
}

export default InfoNotFound;
